<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.cycles list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Cycle"
          style="cursor: pointer;" @click="addNewRow" />
        <div class="tool-tip mt-2">Add Cycle</div>
      </div>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Cycle ID</th>
                <th>Cycle Name <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Cycle Prefix</th>
                <th>Arm Code</th>
                <th>Cycle Duration</th>
                <th>Parent Cycle</th>
                <th>Cycle Type</th>
                <th>Cycle Order</th>
                <th>Is Repeatable</th>
                <th>Min Repeats</th>
                <th>Max Repeats</th>
                <th class="text-center sticky-column">Edit</th>
                <th class="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td>
                  <input v-model="newRow.cycleName" class="form-control" type="text"
                    @input="clearNewFieldError('cycleName')" />
                  <div v-if="newRowErrors.cycleName" class="text-danger">{{ newRowErrors.cycleName }}</div>
                </td>
                <td>
                  <input v-model="newRow.cyclePrefix" class="form-control" type="text" />
                </td>
                <td>
                  <input v-model="newRow.armCode" class="form-control" type="text" />
                </td>
                <td>
                  <input v-model="newRow.cycleDuration" class="form-control" type="number" min="0" />
                </td>
                <td>
                  <input v-model="newRow.parentCycle" class="form-control" type="text" />
                </td>
                <td>
                  <input v-model="newRow.cycleType" class="form-control" type="text" />
                </td>
                <td>
                  <input v-model="newRow.cycleOrder" class="form-control" type="number" min="0" />
                </td>
                <td>
                  <select class="form-select" v-model="newRow.isRepeatable">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <td>
                  <input v-model="newRow.minRepeats" class="form-control" type="number" min="0" />
                </td>
                <td>
                  <input v-model="newRow.maxRepeats" class="form-control" type="number" min="0" />
                </td>
                <td class="text-center sticky-column">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && cycles.length === 0">
                <td colspan="12" class="text-center">No data available.</td>
              </tr>

              <!-- Existing rows -->
              <tr v-for="(cycle, index) in cycles" :key="cycle.cycleId">
                <!-- Cycle Name -->
                <td v-if="editIndex !== index">{{ cycle.cycleName }}</td>
                <td v-else>
                  <input v-model="editableRow.cycleName" class="form-control" type="text"
                    @input="clearFieldError('cycleName')" />
                  <div v-if="validationErrors.cycleName" class="text-danger">{{ validationErrors.cycleName }}</div>
                </td>
                <!-- Cycle Prefix -->
                <td v-if="editIndex !== index">{{ cycle.cyclePrefix }}</td>
                <td v-else>
                  <input v-model="editableRow.cyclePrefix" class="form-control" type="text" />
                </td>
                <!-- Arm Code -->
                <td v-if="editIndex !== index">{{ cycle.armCode }}</td>
                <td v-else>
                  <input v-model="editableRow.armCode" class="form-control" type="text" />
                </td>
                <!-- Cycle Duration -->
                <td v-if="editIndex !== index">{{ cycle.cycleDuration }}</td>
                <td v-else>
                  <input v-model="editableRow.cycleDuration" class="form-control" type="number" min="0" />
                </td>
                <!-- Parent Cycle -->
                <td v-if="editIndex !== index">{{ cycle.parentCycle }}</td>
                <td v-else>
                  <input v-model="editableRow.parentCycle" class="form-control" type="text" />
                </td>
                <!-- Cycle Type -->
                <td v-if="editIndex !== index">{{ cycle.cycleType }}</td>
                <td v-else>
                  <input v-model="editableRow.cycleType" class="form-control" type="text" />
                </td>
                <!-- Cycle Order -->
                <td v-if="editIndex !== index">{{ cycle.cycleOrder }}</td>
                <td v-else>
                  <input v-model="editableRow.cycleOrder" class="form-control" type="number" min="0" />
                </td>
                <!-- Is Repeatable -->
                <td v-if="editIndex !== index">{{ cycle.isRepeatable ? "Yes" : "No" }}</td>
                <td v-else>
                  <select class="form-select" v-model="editableRow.isRepeatable">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <!-- Min Repeats -->
                <td v-if="editIndex !== index">{{ cycle.minRepeats }}</td>
                <td v-else>
                  <input v-model="editableRow.minRepeats" class="form-control" type="number" min="0" />
                </td>
                <!-- Max Repeats -->
                <td v-if="editIndex !== index">{{ cycle.maxRepeats }}</td>
                <td v-else>
                  <input v-model="editableRow.maxRepeats" class="form-control" type="number" min="0" />
                </td>
                <!-- Edit Actions -->
                <td class="text-center sticky-column">
                  <template v-if="editIndex !== index">
                    <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                      @click.prevent="editRow(index, cycle)"></i>
                  </template>
                  <template v-else>
                    <i class="fa fa-check action-icon text-success" @click="updateRow(cycle.id)" title="Update"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                  </template>
                </td>
                <!-- Delete -->
                <td class="text-center">
                  <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                    @click="deleteRow(cycle.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mx-0" v-if="cycles.length > 0">
          <div class="col-lg-12 mx-0 px-0">
            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0"
                  active-color="#618bd7" @update:modelValue="loadPage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>

<script src="./CyclesManagement.js"></script>